module.exports = __webpack_public_path__ + "fonts/Arnhem-Bold.2422b62.woff";